export const REPORT_REASONS = Object.freeze([
  'abuse',
  'privacy',
  'advertising',
  'inappropriate',
  'other',
]);

export function buildReportPayload(reason, description = '') {
  if (!REPORT_REASONS.includes(reason)) {
    throw new Error('Invalid report reason');
  }

  const normalizedDescription = String(description || '').trim();

  return {
    reason,
    description: normalizedDescription || null,
  };
}

export function normalizeReportResponse(response) {
  const status = response && response.data && response.data.status;

  if (!['accepted', 'quarantined', 'already_reported'].includes(status)) {
    throw new Error('Invalid report response');
  }

  return { status };
}

export async function reportPost(app, postId, reason, description = '') {
  const response = await app.request({
    method: 'POST',
    url: `${app.forum.attribute('apiUrl')}/yingtao/posts/${postId}/reports`,
    body: buildReportPayload(reason, description),
  });

  return normalizeReportResponse(response);
}
